"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");

var ActorRdfResolveQuadPattern_1 = require("./ActorRdfResolveQuadPattern");
/**
 * A base implementation for rdf-resolve-quad-pattern events
 * that wraps around an RDFJS {@link RDF.Source}.
 *
 * @see RDF.Source
 */


var ActorRdfResolveQuadPatternSource =
/*#__PURE__*/
function (_ActorRdfResolveQuadP) {
  _inherits(ActorRdfResolveQuadPatternSource, _ActorRdfResolveQuadP);

  function ActorRdfResolveQuadPatternSource(args) {
    _classCallCheck(this, ActorRdfResolveQuadPatternSource);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfResolveQuadPatternSource).call(this, args));
  }

  _createClass(ActorRdfResolveQuadPatternSource, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var source;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getSource(action.context, action.pattern);

              case 2:
                source = _context2.sent;
                _context2.next = 5;
                return this.getOutput(source, action.pattern, action.context);

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
    /**
     * Get the metadata of the given action on a source.
     *
     * By default, this method is implemented by listening to the 'metadata' event
     * in the data stream, and resolving the promise to its value.
     *
     * @param {RDF.Source} source An RDFJS source, possibly lazy.
     * @param {Algebra.Operation} operation The operation to apply.
     * @param ActionContext context Optional context data.
     * @param {AsyncIterator<Quad> & Stream} data The data stream that was created by
     *                                            executing source.matchLazy or source.match.
     * @return {() => Promise<{[p: string]: any}>} A lazy promise behind a callback resolving to a metadata object.
     */

  }, {
    key: "getMetadata",
    value: function getMetadata(source, pattern, context, data) {
      return function () {
        return new Promise(function (resolve, reject) {
          data.on('error', reject);
          data.on('end', function () {
            return resolve({});
          });
          data.on('metadata', function (metadata) {
            resolve(metadata);
          });
        });
      };
    }
    /**
     * Get the output of the given action on a source.
     * @param {RDF.Source} source An RDFJS source, possibly lazy.
     * @param {Algebra.Operation} operation The operation to apply.
     * @param ActionContext context Optional context data.
     * @return {Promise<IActorRdfResolveQuadPatternOutput>} A promise that resolves to a hash containing
     *                                                      a data RDFJS stream and an optional metadata hash.
     */

  }, {
    key: "getOutput",
    value: function () {
      var _getOutput = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(source, pattern, context) {
        var data, metadata;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Create data stream
                if (source.matchLazy) {
                  data = source.matchLazy(ActorRdfResolveQuadPatternSource.variableToNull(pattern.subject), ActorRdfResolveQuadPatternSource.variableToNull(pattern.predicate), ActorRdfResolveQuadPatternSource.variableToNull(pattern.object), ActorRdfResolveQuadPatternSource.variableToNull(pattern.graph));
                } else {
                  // TODO: AsyncIterator fix typings
                  data = asynciterator_1.AsyncIterator.wrap(source.match(ActorRdfResolveQuadPatternSource.variableToNull(pattern.subject), ActorRdfResolveQuadPatternSource.variableToNull(pattern.predicate), ActorRdfResolveQuadPatternSource.variableToNull(pattern.object), ActorRdfResolveQuadPatternSource.variableToNull(pattern.graph)));
                } // Create metadata callback


                metadata = ActorRdfResolveQuadPatternSource.cachifyMetadata(this.getMetadata(source, pattern, context, data));
                return _context3.abrupt("return", {
                  data: data,
                  metadata: metadata
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getOutput(_x3, _x4, _x5) {
        return _getOutput.apply(this, arguments);
      }

      return getOutput;
    }()
  }], [{
    key: "variableToNull",
    value: function variableToNull(term) {
      if (term && term.termType === 'Variable') {
        return null;
      }

      return term;
    }
    /**
     * Convert a metadata callback to a lazy callback where the response value is cached.
     * @param {() => Promise<{[p: string]: any}>} metadata A metadata callback
     * @return {() => Promise<{[p: string]: any}>} The callback where the response will be cached.
     */

  }, {
    key: "cachifyMetadata",
    value: function cachifyMetadata(metadata) {
      var lastReturn = null;
      return function () {
        return lastReturn || (lastReturn = metadata());
      };
    }
  }]);

  return ActorRdfResolveQuadPatternSource;
}(ActorRdfResolveQuadPattern_1.ActorRdfResolveQuadPattern);

exports.ActorRdfResolveQuadPatternSource = ActorRdfResolveQuadPatternSource;